export default "__VITE_ASSET__QSROnitM__"